module.exports = __webpack_public_path__ + "img/dbzq.6e23cdd8.png";